/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useContext, useRef, useCallback, useMemo } from "react";
import { salesService } from "../../services/sales.service";
import { Dropdown } from "react-bootstrap";
import LogicContext from "../../Context/LogicContext";
import { SetSalesOrderReturnAtom, GetSalesOrderReturnAtom } from '../../store/salesOrderReturnAtom';
import CurrencyFormat from "react-currency-format";
import Tooltip from "@mui/material/Tooltip";
import RestartAlt from "@mui/icons-material/RestartAlt";
import { useState } from "react";
import GeneralModal from "../../helpers/GeneralModal";
import { createModal } from "react-modal-promise";
import { useLocation, useNavigate } from "react-router-dom";
import ActionPaneComponent from "../../helpers/ActionPaneComponent";
import { IoMdRefresh } from "react-icons/io";
import { useForm } from "react-hook-form";
import moment from "moment";
import { FaPlus } from "react-icons/fa";
import GeneralCustomTable from "../../helpers/GeneralCustomTable";
import { formatCustomNumber } from "../../helpers/formatCustomNumber";
import { formatCustomDate } from "../../helpers/formatCustomDate";
import { toLowercaseKeys } from "../../helpers/toLowerCaseKeys";
import StatusBadge from "../../generals/StatusBadge";
// import SalesOrderFilter from "./SalesOrderFilter";

const SalesOrderReturnMinPage = () => {
  const { pathname } = useLocation();
  const { register, setValue, getValues, handleSubmit, reset, formState: { errors } } = useForm();
  const navigate = useNavigate();
  const url = pathname.split("/");
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];
  const { showToast } = useContext(LogicContext); // Select only needed context value
  const setSalesReturnAtom = SetSalesOrderReturnAtom();
  const salesReturnAtom = GetSalesOrderReturnAtom();
  const myPromiseModal = createModal(GeneralModal);
  const [tableData, setTableData] = useState([]);
  const mountRef = useRef(false);
            const [searchText, setSearchText] = useState("");
  

  // Memoized columns to prevent recreation
  const columns = useMemo(
    () => [
      {
        title: 'Reference',
        key: 'return_ref_no',
        dataIndex: 'return_ref_no',
        className: 'text-primary',
        sorter: (a, b) => (a?.return_ref_no ?? '') - (b?.return_ref_no ?? ''),
      },
      {
        title: 'Return Date',
        dataIndex: 'return_date',
        sorter: (a, b) => (a?.return_date ?? '').localeCompare(b?.return_date ?? ''),
         render: (record) => <span>{formatCustomDate(record)}</span>,
      },
      {
        title: 'Order Number',
        dataIndex: 'sales_order_no',
        sorter: (a, b) => (a?.sales_order_no ?? '').localeCompare(b?.sales_order_no ?? ''),
      },
      {
        title: 'Customer Name',
        dataIndex: 'customer_full_name',
        sorter: (a, b) => (a?.customer_full_name ?? '').localeCompare(b?.customer_full_name ?? ''),
      },
      {
        title: 'Email',
        dataIndex: 'customer_email_address',
        sorter: (a, b) => (a?.customer_email_address ?? '').localeCompare(b?.customer_email_address ?? ''),
      },
      {
        title: 'Status',
        dataIndex: 'return_status_name',
        sorter: (a, b) => (a?.return_status_name ?? '').localeCompare(b?.return_status_name ?? ''),
        render: (record, row) => <StatusBadge statusId={row?.return_status_id} statusName={record} />,
      },

  
    ],
    []
  );

  // Set table data from global state
  useEffect(() => {
    mountRef.current = true;
    if (salesReturnAtom?.so_return_main?.length > 0) {
      setTableData(salesReturnAtom.so_return_main);
    }else{
      getPurchaseOrderListApi();
    }
    return () => {
      mountRef.current = false;
    };
  }, [salesReturnAtom]);

 

  // Fetch sales order list with abortable request
  const getPurchaseOrderListApi = useCallback(async () => {
    try {
      const response = await salesService.getSalesOrderReturnList();
      const serverData =  toLowercaseKeys(response.data);
        setSalesReturnAtom(serverData);
      
    } catch (err) {
     console.log("Error ", err);
    }
  }, []);




  const searchByDate = useCallback(async () => {
    const formData = getValues();
    try {
      const response = await salesService.getSalesOrderReturnListByDate(formData);
      const searchResult =  toLowercaseKeys(response.data);
      if (searchResult?.so_return_main?.length) {
        setTableData(response.data.so_return_main);
      } else {
        showToast('No result found', '');
        setTableData([]);
      }
    } catch (err) {
      showToast("Error", "error");
    }
  }, [getValues, showToast]);

  const handleRowClick = useCallback(
    (data) => {
      const id = data['return_ref_no'];
      navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/details/${id}`);
    },
    [currModuleId, currModuleName, currUserMenu, navigate]
  );

  // Memoized summary cards to avoid redundant renders


  const onClearInput = ()=> {
    setSearchText("");
    setTableData(salesReturnAtom.so_return_main || []);

   }



  const handleSearch = (text) => {
    setSearchText(text);
   
     if (text.trim() === "") {
      setTableData(salesReturnAtom.so_return_main || []);
       return;
     }
   
     const searchTerm = text.toLowerCase();
     const filtered = (salesReturnAtom.so_return_main || []).filter(credit =>
       Object.values(credit).some(value => value?.toString().toLowerCase().includes(searchTerm))
     );
     setTableData(filtered); 
   };

  return (
    <>
     

      <div className="mt-6 md:flex items-end justify-between space-y-3 md:space-y-0">
        <div className="flex items-center space-x-2">
          {/* {itemSelected.length > 0 ? (
            <Dropdown>
              <Dropdown.Toggle id="dropdown-basic">Bulk Actions</Dropdown.Toggle>
              <Dropdown.Menu>
                {salesOrderData["Bulk_Action"]?.map((action, i) => (
                  <Dropdown.Item key={i} onClick={() => bulkActions(action)}>
                    {action.Action_Name}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          ) : (
            <div></div>
            // <SalesOrderFilter list={salesOrderData["Filtering_Criteria"]} onFilterSelect={onFilterSelect} />
          )} */}
          <Tooltip title="Reload">
            <div
              onClick={getPurchaseOrderListApi}
              className="h-fit w-fit p-2 rounded-full cursor-pointer hover:bg-gray-200 active:bg-gray-300"
            >
              <IoMdRefresh className="h-[20px] w-[20px] text-gray-600" />
            </div>
          </Tooltip>
        </div>

        <div className="flex flex-row items-end space-x-2">
          <div>
            <span className="ml-1 text-sm">From Date:</span>
            <input
              defaultValue={moment(Date.now()).format("YYYY-MM-DD")}
              {...register("from_date")}
              className="bg-white ring-1 ring-gray-200 w-full pl-3 rounded max-h-full outline-none border-transparent focus:border-transparent focus:ring-0"
              type="date"
            />
          </div>
          <div>
            <span className="ml-1 text-sm">To Date:</span>
            <input
              {...register("to_date")}
              defaultValue={moment(Date.now()).format("YYYY-MM-DD")}
              className="bg-white ring-1 ring-gray-200 w-full pl-3 rounded max-h-full outline-none border-transparent focus:border-transparent focus:ring-0"
              type="date"
            />
          </div>
          <div>
            <button
              onClick={searchByDate}
              type="button"
              className="text-sm text-white px-3 bg-blue-500 rounded py-2.5"
            >
              Search
            </button>
          </div>
        </div>

        {/* <div className="flex items-center space-x-4">
          <Tooltip title="Add New">
            <button
              onClick={addNewInvoice}
              className="ml-2 h-fit w-fit px-3 py-2.5 bg-gray-200 border-[1.5px] border-gray-300 rounded-md text-white focus:outline-none font-medium hover:bg-gray-100 active:bg-gray-200 transition-all duration-200"
            >
              <FaPlus className="h-[16px] w-[16px] text-gray-600" />
            </button>
          </Tooltip>
        </div> */}

      </div>

                  {/* Start of search */}
    <div className="flex justify-center mt-4">
    <div className="flex flex-col w-full md:w-1/3">
      <input
        type="text"
        placeholder="Search in table"
        value={searchText}
        onKeyDown={(e) => {
          if (e.key === 'Backspace') {
            onClearInput();
          }
        }}
        onChange={(e) => handleSearch(e.target.value)}
        className="bg-white ring-1 ring-gray-200 w-full pl-3 py-2 rounded outline-none focus:ring-blue-300"
      />
    </div>
  </div>
  {/* End of search */}

      <section className="mt-5">
        <GeneralCustomTable
          tableHeadList={columns}
          tableDataList={tableData}
          allowCheckBox={false}
          setSelectedRows={(sel)=>  console.log("sel", sel) }
          rowKey={(record) => record.return_ref_no}
          handleRowClick={handleRowClick}
        />
      </section>
    </>
  );
};

export default SalesOrderReturnMinPage; // Memoize component